import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../Footer';
import { Link, Navigate } from 'react-router-dom';
import axios from 'axios';

const DeleteAccount = () => {
    const [redirect, setRedirect] = useState(false);

    const getDataFromLocalStorage = (key) => {
        try {
            const serializedData = localStorage.getItem(key);
            return serializedData ? JSON.parse(serializedData) : null;
        } catch (error) {
            console.error('Error getting data from localStorage:', error);
            return null;
        }
    };

    const storedUserPreferences = getDataFromLocalStorage('userData');

    const handleDeleteConfirmation = () => {
        const isConfirmed = window.confirm(
            "Are you sure you want to delete your Carloca account? Once deleted, you will lose all your saved cars, listings, and purchase history. This action cannot be undone."
        );

        if (isConfirmed) {
            deleteAccount();
        }
    };

    const deleteAccount = async () => {
        try {
            const response = await axios.post(
                window.CARLOCA_API + "/user/delete",
                { user_id: storedUserPreferences?.id }
            );

            if (response?.data?.status) {
                localStorage.removeItem('userData');
                setRedirect(true);
            }
        } catch (error) {
            console.log("An error occurred while deleting the account.", error);
        }
    };

    return (
        <>
            <Navbar />
            <div className="cl-page">
                <div className="col-lg-7 col-md-9 col-sm-12 px-3 mx-auto">
                    <h2 className="cl-page-title">Delete Account</h2>
                    <div className="card mt-3 border-0">
                        <div className="card-body pb-1">
                            <h4 className="text-center blue mb-4">
                                We don’t want to say <span className="fw-bold">Goodbye</span> 🚗
                            </h4>
                            <p className="text-center text-muted mb-4">
                                Carloca (<a href="https://carloca.co.uk" target="_blank" className='text-decoration-underline text-primary' rel="noreferrer">carloca.co.uk</a>) 
                                is your trusted platform to <strong>buy</strong> and <strong>sell cars</strong>.  
                                Deleting your account means you will permanently lose:
                            </p>
                            <ul className="p-0 list-unstyled">
                                <li className="d-flex mb-3 blue">
                                    <i className="fa-solid fa-check me-2 pt-1"></i> Saved cars in your watchlist
                                </li>
                                <li className="d-flex mb-3 blue">
                                    <i className="fa-solid fa-check me-2 pt-1"></i> Active car sale listings
                                </li>
                                <li className="d-flex mb-3 blue">
                                    <i className="fa-solid fa-check me-2 pt-1"></i> Purchase and sales history
                                </li>
                                <li className="d-flex mb-3 blue">
                                    <i className="fa-solid fa-check me-2 pt-1"></i> Access to Carloca community offers
                                </li>
                                <li className="d-flex mb-3 blue">
                                    <i className="fa-solid fa-check me-2 pt-1"></i> Personalized car recommendations
                                </li>
                            </ul>
                            <p className="text-danger small mt-3">
                                Once deleted, your Carloca account and all associated data cannot be recovered.
                            </p>
                        </div>
                    </div>
                    <div className="d-flex mt-3 justify-content-between">
                        <Link to="/profileSetting" className="cl-btn cl-btn-outline cl-btn-sm">
                            Cancel
                        </Link>
                        <button
                            className="cl-btn cl-btn-danger cl-btn-sm"
                            onClick={handleDeleteConfirmation}
                        >
                            Delete Account
                        </button>
                    </div>
                </div>
                <Footer />
                {redirect && <Navigate to="/" />}
            </div>
        </>
    );
};

export default DeleteAccount;
